import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { AuthService } from "../services/auth.service";

@Injectable({ providedIn: 'root' })
export class LoggedInGuard
{
    constructor(private authService: AuthService, 
        private router: Router
        ) { }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) 
    {
        const userLoggedIn = await this.authService.userLoggedIn();

        // console.log('LoggedInGuard: canActivate: userLoggedIn: ' + userLoggedIn);
        if (userLoggedIn) return true;
        this.router.navigate(['login']);
        return false;
    }
}
